// extracted by mini-css-extract-plugin
export default {"list-item":"ListItem_list-item__oAYH+","thumbnail":"ListItem_thumbnail__9IjEh","text":"ListItem_text__XUyiu","title":"ListItem_title__Rik2C"};